module.exports = __webpack_public_path__ + "static/media/girl-scooping-chocolate-finger.8d3d5203.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/girl-scooping-chocolate-finger.jpg
// module id = 828
// module chunks = 0